// Share-URL builder (P1-6, MR-12). Builds direct network share URLs (the
// widget previously routed shares through a third-party oexchange forwarder
// that was shut down in 2023). Used by v4 Controls/Menu.vue and v3 Share.vue.
// Pure + unit-tested (test/unit/share.spec.js); no network/DOM.
//
// Accepts each caller's native share-type vocabulary: v4 Menu uses
// 'email'/'meta'/'x'; v3 Share uses 'email'/'facebook'/'twitter'. Values are
// URL-encoded internally — pass raw url/title.

// eslint-disable-next-line import/prefer-default-export
export const buildShareLink = (type, { url = '', title = '' } = {}) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);

  switch (type) {
    case 'email':
      return `mailto:?body=${u}&subject=${t}`;
    case 'facebook':
    case 'meta':
      // FB's sharer ignores any title/quote param — pass only the URL.
      return `https://www.facebook.com/sharer/sharer.php?u=${u}`;
    case 'twitter':
    case 'x':
      // Deliberately the twitter.com/intent/tweet endpoint: it 301-redirects
      // to X's live intent flow and is battle-tested. x.com/intent/post is the
      // post-rebrand form but uses a different param contract — not worth the
      // risk here (MR-12 review nit, kept intentionally).
      return `https://twitter.com/intent/tweet?url=${u}&text=${t}`;
    default:
      // Never throw: v3 Share is mounted via v-show, so computedShareLink
      // evaluates on every PlayerInfo render — a throw here would blank the
      // whole player, not just one link. Degrade to an email share (the
      // pre-refactor switch's mailto default). Callers only ever pass known
      // literal types; this is purely a future-edit safety net.
      return `mailto:?body=${u}&subject=${t}`;
  }
};
